// 滞在に入らなかった買い物をタイムラインに出す 1 行
//
// 滞在カードの中と違って場所名が無いので、店名（加盟店名）も並べる。
// レシートはタップでレシート画面の詳細へ飛ぶ。
// レシートの無いカード利用はタップで、もらえなかったレシートとして手で登録できる。
// 加盟店名はカード会社の表記（カタカナなど）で Google の検索は外れやすいので、場所探しで Google は引かない。
import { CreditCard, ReceiptText } from 'lucide-react'
import { useState } from 'react'
import { useNavigate } from 'react-router'

import { formatSpendingTime, type UnassignedSpending } from '@/lib/receipt-visit-utils'
import { ReceiptCreateSheet } from '@/pages/receipts/components/receipt-create-sheet'
import { draftFromCardTransaction } from '@/pages/receipts/receipt-create-form'
import { RECEIPT_RETURN_STATE } from '@/pages/receipts/receipt-query'
import { PATHS } from '@/routes/paths'

const formatAmount = (amount: number | null): string => (amount === null ? '金額不明' : `¥${amount.toLocaleString()}`)

type Props = {
  spending: UnassignedSpending
}

export const SpendingRow = ({ spending }: Props) => {
  const navigate = useNavigate()
  const [isCreateOpen, setIsCreateOpen] = useState(false)

  if (spending.kind === 'card') {
    const tx = spending.transaction
    return (
      <>
        <button
          type="button"
          onClick={() => setIsCreateOpen(true)}
          className="flex w-full items-start gap-2 rounded-md border border-dashed border-amber-500/40 px-3 py-2 text-left text-sm text-muted-foreground hover:bg-amber-500/10"
        >
          <CreditCard className="mt-0.5 size-4 shrink-0 text-amber-600" />
          <span className="shrink-0 tabular-nums">{formatSpendingTime(tx.used_at)}</span>
          <span className="min-w-0 flex-1 wrap-break-word">
            {tx.merchant}
            <span className="ml-1 text-xs">（レシート未登録）</span>
          </span>
          <span className="shrink-0 tabular-nums">{formatAmount(tx.amount)}</span>
        </button>
        <ReceiptCreateSheet
          open={isCreateOpen}
          onOpenChange={setIsCreateOpen}
          initialDraft={draftFromCardTransaction(tx)}
          useGoogle={false}
        />
      </>
    )
  }

  const receipt = spending.receipt
  return (
    <button
      type="button"
      onClick={() => navigate(`${PATHS.RECEIPTS.LIST}?id=${receipt.id}`, { state: RECEIPT_RETURN_STATE })}
      className="flex w-full items-start gap-2 rounded-md bg-amber-500/10 px-3 py-2 text-left text-sm hover:bg-amber-500/20"
    >
      <ReceiptText className="mt-0.5 size-4 shrink-0 text-amber-600" />
      <span className="shrink-0 tabular-nums">{formatSpendingTime(receipt.purchased_at)}</span>
      <span className="min-w-0 flex-1 wrap-break-word">
        <span className="font-medium">{receipt.store_name || '店名なし'}</span>
        {receipt.item_names.length > 0 && (
          <span className="ml-1 text-xs text-muted-foreground">{receipt.item_names.join('、')}</span>
        )}
      </span>
      <span className="shrink-0 tabular-nums">{formatAmount(receipt.total_amount)}</span>
    </button>
  )
}
